export enum IdentityProvider {
  Google = 'google',
  LinkedIn = 'linkedin',
}
